<template>
    <div class="exchange_detail">
        <div v-if="detail">
            <VanImage   lazy-load  :src="detail.imgurl" width="100%" fit="fill"></VanImage>
            <div class="exchange_detail_body">
                <div class="exchange_detail_info">
                    <div>
                        <div class="van-ellipsis">{{detail.title}}</div>
                    </div>
                    <div>
                        <div>
                            {{detail.shortdesc}}
                        </div>
                    </div>
                </div>
                <div class="exchange_detail_intro">
                    <div v-html="detail.description"></div>
                </div>
            </div>
            <Popup closeable @close="passwordClose"  v-model="password_show" position="bottom" :style="{ height: '100vh' }">
                <div class="password">
                    <password-input
                            :value="password"
                            info="请输入确认密码"
                            :focused="showKeyboard"
                            @focus="showKeyboard = true"
                    />
                    <!-- 数字键盘 -->
                    <number-keyboard
                            :show="showKeyboard"
                            @input="onInput"
                            @delete="onDelete"
                            @blur="showKeyboard = false"
                    />
                </div>
            </Popup>

            <Footbar>
                <div class="footer" slot="footbar">
                    <Button  block round color="#FF7B4E" :disabled="detail.disabled" @click="checkIn" :loading="loading">
                        {{detail.tips}}
                    </Button>
                </div>
            </Footbar>
        </div>
    </div>
</template>
<script>
    import {Button,Image,PasswordInput,NumberKeyboard,Popup} from 'vant';
    import './Detail.less'
    import Footbar from 'components/footbar'
    export default {
        name: "checkDetail",
        data() {
            return {
                showKeyboard: true,
                password_show:false,
                password:"",
                loading: false,
                detail:'',
                params: this.$route.query,
                activity_sub_id: "",
                code: ""
            }
        },
        components: {
            Button,
            Footbar,
            VanImage:Image,
            NumberKeyboard,
            PasswordInput,
            Popup
        },
        methods: {
            onInput(key) {
                this.password = (this.password + key).slice(0, 6);
                if(this.password.length === 6){
                    this.checkInRequest()
                }
            },
            onDelete() {
                this.password = this.password.slice(0, this.password.length - 1);
            },
            passwordClose(){
              this.password = '';
              this.loading = false;
              this.password_show = false;
            },
            taskDetail() {
                this.$api.activity.taskDetail(Object.assign(this.params, {expand: 'playerInfo'})).then((res) => {
                    if (res.status * 1 === 200) {
                        if (res.data.playerInfo) {
                            res.data.tips = '已完成';
                            res.data.disabled = true;
                        } else if (res.data.type === 1) {
                            res.data.tips = '立即扫码';
                        } else if (res.data.type === 2) {
                            res.data.tips = '立即完成'
                        }
                        this.detail = res.data;
                    }
                })
            },
            checkInRequest: function () {
                if(this.detail.password*1!==0 && !this.password){
                    this.password_show  =   true;
                    return;
                }
                this.$api.activity.taskCheckin(Object.assign({}, this.params, {
                    type: this.detail.type,
                    code: this.code,
                    activity_sub_id: this.activity_sub_id,
                    password:this.password
                })).then(() => {
                    this.taskDetail();
                    this.$dialog.alert({
                        title: "提示",
                        message: this.detail.alertstring ? this.detail.alertstring : '操作成功'
                    }).then(() => {
                        if(this.detail.jumpurl){
                            window.location.href = this.detail.jumpurl;
                        }
                        // on close
                    });
                    this.passwordClose()
                },()=>{
                    this.passwordClose()
                })
            },
            checkIn: function () {
                let that = this;
                this.loading = true;
                if (this.detail.type * 1 === 1) {
                    if(!this.$wechat.bridge.isWeChat){

                        this.$dialog.alert({
                            title:"提示",
                            message:"请在微信中打开连接"
                        })
                        this.loading = false;
                        return ;
                    }

                    this.$wechat.scanQRCode().then((res) => {
                        if (res) {
                            this.code = res
                            this.checkInRequest();
                        } else {
                            this.loading = false;

                        }
                    }, () => {
                        this.loading = false;
                    })

                } else {
                    that.activity_sub_id = this.detail.id;
                    //判断是否需要密码 如果不需要则要弹框确认
                    if(this.detail.password*1===0){
                        this.$dialog.confirm({
                            title: '标题',
                            message: '确定完成任务?',
                        }).then(() => {
                            that.checkInRequest();
                        }).catch(() => {
                            this.loading = false;
                            // on cancel
                        });
                    }else{
                        that.checkInRequest();
                    }
             }
            }
        },
        mounted() {
            this.$nextTick(() => {

                this.$wechat.config();
                this.taskDetail()
            })
        }
    }
</script>

